import { Benchmark } from '@cibo/core'
import { JSXElementConstructor, createContext, useContext } from 'react'

export interface IBenchmarkModalContext {
  showBenchmarkModal: (
    programId: string,
    benchmark: Benchmark,
    fieldId: string,
    DialogActions?: BenchmarkStatusModalStateDialogActions
  ) => void
}

export type BenchmarkStatusModalStateDialogActions = JSXElementConstructor<{
  resourceId: string
  benchmark: Benchmark
  programId: string
  onCloseDialog: () => void
}>

export const BenchmarkModalContext = createContext<IBenchmarkModalContext>({
  showBenchmarkModal: () => null,
})
BenchmarkModalContext.displayName = 'BenchmarkModalContext'

export const useBenchmarkModal = () => useContext(BenchmarkModalContext)
